export default __webpack_public_path__ + "static/media/play-white.4dcc1c1c.svg";